var React = require('react');

function Florring (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","d":"M106.946 50.163H2L25.302 2h58.341l23.303 48.163ZM36.237 2 21.323 50.163M48.066 2l-5.36 48.163M59.241 2l4.194 48.163M70.835 2l13.982 48.163M13.651 26.081H28.78m4.13-13.34h13.96m-2.352 21.136h17.5M59.814 8.583h12.932m-8.612 31.878h17.867m-3.018-10.395h18.24"}));
}

Florring.defaultProps = {"width":"109","height":"52","fill":"none","stroke":"#FF913A","viewBox":"0 0 109 52"};

module.exports = Florring;

Florring.default = Florring;
